@use '../../styling/badges.scss' as *;
@use '../../styling/colors.scss' as *;

.RunStatusBadge {
  @extend %badge-base;

  min-width: 100px; //Incomplete is the longest
  white-space: nowrap;
  border: 2px solid $color-highlight-blue;

  &.PASSED {
    border-color: $color-primary-green;
    color: $color-primary-green;
  }

  &.SUCCESS {
    border-color: $color-primary-green;
    color: $color-primary-green;
  }

  &.FAILED {
    border-color: $color-primary-red;
    color: $color-primary-red;
  }

  &.INCOMPLETE,
  &.RUNNING,
  &.STARTED {
    border-color: $color-primary-purple;
    color: $color-primary-purple;
  }

  &.CANCELLED {
    border-color: $color-grey-B;
    color: $color-grey-B;
  }

  &.ERROR {
    border-color: $color-warning-orange;
    color: $color-warning-orange;
  }
}
